var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class AspectMountDimensions {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectMount() {
        return this.parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    get aspectWidthInPixel() {
        const width = Math.floor(this.aspectMount.measureDom.expectedOrMeasuredOffset.width);
        if (width)
            return width;
        return Math.max(this.aspect.scaledValueOf.minWidth, this.aspect.scaledValueOf.width) || 0;
    }
    get aspectHeightInPixel() {
        const height = Math.floor(this.aspectMount.measureDom.expectedOrMeasuredOffset.height);
        if (height)
            return height;
        return Math.max(this.aspect.scaledValueOf.minHeight, this.aspect.scaledValueOf.height) || 0;
    }
    get aspectWidthInUnits() {
        return Math.round(this.aspectWidthInPixel / this.aspect.context.stage.stageInnerMeasure.stageWidthRatio);
    }
    get aspectHeightInUnits() {
        return Math.round(this.aspectHeightInPixel / this.aspect.context.stage.stageInnerMeasure.stageHeightRatio);
    }
}
__decorate([
    computed
], AspectMountDimensions.prototype, "aspectWidthInPixel", null);
__decorate([
    computed
], AspectMountDimensions.prototype, "aspectHeightInPixel", null);
